export const REASONS_TO_SHOP_TITLE = 'Reasons to shop widget title';
